export const orgCostCenter = {
  header: 'Tous les centres de coûts ({{count}})',
  code: 'Code',
  active: 'Statut',
  name: 'Nom',
  currency: 'Devise',
  unit: 'Unité parente',
  actions: '',
  sortBy: 'Trier par',
  sort: {
    byName: 'Nom',
    byUnitName: 'Unité',
    byCode: 'Code',
  },
  hint: 'Toutes les commandes passées par le compte d\'achat de votre organisation sont liées à un centre de coûts à des fins de suivi. Chaque unité peut avoir plusieurs centres de coûts. Pour limiter les dépenses, des budgets sont assignés aux centres de coûts. Un acheteur sélectionne un centre de coûts lors du passage à la caisse.',
  disable: {
    confirm: 'Désactiver',
  },
  messages: {
    deactivateTitle: 'Désactiver ce centre de coûts?',
    deactivate: 'Les centres de coûts désactivés ne peuvent pas être utilisés pour passer de nouvelles commandes. Assurez-vous que votre unité dispose d\'au moins un centre de coûts. Les commandes existantes ne sont pas affectées.',
    confirmEnabled: 'Centre de coûts {{ item.name }} activé avec succès',
    confirmDisabled: 'Centre de coûts {{ item.name }} désactivé avec succès',
    update: 'Centre de coûts {{ item.name }} mis à jour avec succès',
    create: 'Centre de coûts {{ item.name }} créé avec succès',
  },
  info: {
    disabledEdit: 'Activez le centre de coûts pour permettre la modification.',
    disabledEnable: 'L\'unité doit être activée avant que ce centre de coûts puisse être activé.',
  },
  details: {
    title: 'Détails du centre de coûts',
    subtitle: 'Centre de coûts : {{ item.name }}',
  },
  edit: {
    title: 'Modifier le centre de coûts',
    subtitle: 'Centre de coûts : {{ item.name }}',
  },
  create: {
    title: 'Créer un centre de coûts',
    subtitle: '',
  },
  budget: {
    link: 'Budgets',
  },
  breadcrumbs: {
    list: 'Tous les centres de coûts',
    details: '{{name}}',
    budgets: 'Budgets',
  },
};

export const orgCostCenterAssignedBudgets = {
  title: 'Budgets assignés',
  subtitle: 'Centre de coûts : {{ item.name }}',
  assigned: 'Budget {{ item.name }} assigné avec succès',
  unassigned: 'Budget {{ item.name }} désassigné avec succès',
};

export const orgCostCenterBudgets = {
  title: 'Gérer les budgets',
  subtitle: 'Centre de coûts : {{ item.name }}',
  assigned: 'Budget {{ item.name }} assigné avec succès',
  unassigned: 'Budget {{ item.name }} désassigné avec succès',
};
